import { tiles } from '../../../../common/tiles_fl';

export default [
  { item: tiles.subjectSearch },
  {
    item: tiles.onboardingSnapshot,
    requiresActiveProject: true,
  },
  {
    item: tiles.fileValidation,
    requiresActiveProject: true,
  },
  {
    item: tiles.regenerativeMedicineOps,
    requiresActiveProject: true,
  },
  {
    item: tiles.zoriPulsePriorities,
    requiresActiveProject: true,
  },
  {
    item: tiles.zoomAppointments,
    requiresActiveProject: true,
  },
  {
    item: tiles.aiRules,
    requiresActiveProject: true,
  },
  { item: tiles.manageProjectConsent },
  { item: tiles.manageSurveys },
  { item: tiles.genomics },
  { item: tiles.employees },
  { item: tiles.files },
];
